import mrCoinImg from "assets/images/funds/mrcoin.jpg";

export const FUNDS = [
    {
        name: "MrCoin",
        buyUrl: "https://www.mrcoin.eu/en/exchange/Euro/EUR/to/Augmint-Euro-Token/AEUR",
        sellUrl: "https://www.mrcoin.eu/en/exchange/Augmint-Euro-Token/AEUR/to/Euro/EUR",
        addFeatures: ["1:1 exchange rate", "0.25% exchange fee", "Additional banking fees may apply"],
        withdrawFeatures: ["1:1 exchange rate", "0.25% exchange fee", "Additional banking fees or taxes may apply"],
        image: mrCoinImg,
        aeurLimit: 15,
        eurLimit: 25
    }
];
